import React from 'react';
import { services } from '../mockData';

const MarketConsulting = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-white via-pink-50/20 to-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div>
              <div className="inline-block">
                <div className="h-1 w-16 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-4"></div>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Market Consulting Services
              </h2>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              TYJ Group offers a specialist consultancy service to advise on delivering best-in-class research and insight. We are a full-service market research company that conducts both qualitative and quantitative Market Research solutions.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Experienced Market Research agency providing panel and full-service research solutions, online survey programming, hosting, and reporting services to the market research industry. Our researchers, technical teams, and panel managers have decades of market research experience specializing in online and mobile surveys and telephone interviews.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              We also use our expertise to work with your business so your standards are exemplary and staff is skilled giving you confidence that you are fully compliant.
            </p>

            {/* Services List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
              {services.consulting.map((service) => (
                <div
                  key={service.id}
                  className="flex items-center space-x-2 text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                >
                  <div className="w-2 h-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full"></div>
                  <span className="text-sm font-medium">{service.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Illustration */}
          <div className="relative">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=800&fit=crop"
                alt="Market Consulting"
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-4 -right-4 w-full h-full border-4 border-pink-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketConsulting;
